// extracted by mini-css-extract-plugin
module.exports = {"container":"newBusinessInsightsMenu_container__dZZTq","insightsList":"newBusinessInsightsMenu_insightsList__WPRq0","active":"newBusinessInsightsMenu_active__1DEDk"};